import type { ScoringResult } from '@mathflat/domain/Scoring'
import type { WorksheetTag } from '@mathflat/domain/Worksheet'

import { EXAM_AND_CATEGORY_WORKSHEET_TAG_LIST } from '@/constant'
import type { Worksheet } from '@/dto'
import { RouteName } from '@/router/RouteName'

const worksheetUtil = {
  isExamOrCategoryWorksheetTag: (tag: WorksheetTag | undefined | null) => {
    if (!tag) return false
    return EXAM_AND_CATEGORY_WORKSHEET_TAG_LIST.map<WorksheetTag>((tag) => tag.value).includes(tag)
  },
  isCsatSubMenu: (path: string) => {
    return (
      path === RouteName.practiceTest ||
      path === RouteName.practiceTestPair ||
      path === RouteName.satWorksheet ||
      path === RouteName.policeMilitaryPracticeTest ||
      path === RouteName.policeMilitaryPracticeTestPair ||
      path === RouteName.kmmExamWorksheet
    )
  },
  // 내신관(내신기출) 라우트 그룹
  isSchoolExamSubMenu: (path: string) => {
    return (
      path === RouteName.textbookWorksheet ||
      path === RouteName.recommend ||
      path === RouteName.schoolTest
    )
  },
  getKorWorksheetFilterType: (filterType: Worksheet['filterType']) => {
    if (filterType === 'CONCEPT') return '단원유형별'
    if (filterType === 'PRACTICE_TEST') return '수능모의고사'
    if (filterType === 'PUBLIC_WORKBOOK') return '교재'
    if (filterType === 'SCHOOL_TEST') return '내신기출'
    if (filterType === 'CUSTOM_PAPER') return '기출업로드(기타 지류)'
    if (filterType === 'SCHOOL_TEST_PAPER') return '기출업로드(기출시험지)'
    if (filterType === 'ONE_CLICK') return '복습'
    if (filterType === 'MERGED_WORKSHEET') return '병합학습지'
    if (filterType === 'MY_DB_ORIGINAL') return '나의 DB(원본)'
    if (filterType === 'MY_DB_SIMILAR') return '나의 DB(유사)'
    if (filterType === 'WEAK_CONCEPT') return '단원유형별오답학습지'
    if (filterType === 'WEAK_PERIOD') return '기간별오답학습지'
    if (filterType === 'WEAK_WORKSHEET') return '학습지별오답학습지'
    return ''
  },

  getKorScoringResult: (isSubmitted: boolean, scoringResult: ScoringResult) => {
    if (isSubmitted) {
      if (scoringResult === 'CORRECT') return '채점_정답'
      if (scoringResult === 'WRONG') return '채점_오답'
      if (scoringResult === 'UNKNOWN') return '채점_모름'
      return '채점전'
    } else {
      if (scoringResult === 'CORRECT') return '가채점_정답'
      if (scoringResult === 'WRONG') return '가채점_오답'
      if (scoringResult === 'UNKNOWN') return '가채점_모름'
      return '채점전'
    }
  },
}

export default worksheetUtil
